<script setup lang="ts">
import { ref } from "vue";
import DRBanner from "../UI/DRBanner.vue";
import ReportImg from "/images/illustrations/report.png";
import ImportTemplateDialog from "./ImportTemplateDialog.vue";
import { t } from "i18next";

const props = defineProps<{
  projectId?: number;
}>();

const show = ref(false);

const actions = [
  {
    label: t("report:diagnostics.templates.banner.message"),
    handler: () => {
      show.value = true;
    },
  },
];
</script>

<template>
  <DRBanner
    class="mb-3"
    :img="ReportImg"
    :title="$t('report:diagnostics.template.banner.title')"
    :actions="actions"
  />

  <ImportTemplateDialog v-model="show" :projectId="props.projectId" />
</template>
